// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3ZTYA","productName":"Table_productName__2amw5"};